// @flow

// Effect Managers
import { call, fork, put, take, select, race } from 'redux-saga/effects'

// Selectors
import featureOperation$ from '../selectors/featureOperation'
import { selectedField$ } from 'hfty-map'

// Constants
import {
  DELETE_SELECTED_FIELD,
} from '../constants'

// Operators
import featureOperator from '../featureOperator'

// Controllers
import controller from 'fc-ctrl-assets'

// Utils
import traverse from 'fc-utils/traverse'

// Exports
export default function *watchDeleteSelectedField (): Generator<*, void, *> {
  while (true) {
    yield take(DELETE_SELECTED_FIELD)
    yield fork(handleDeleteSelectedField)
  }
}

export function *handleDeleteSelectedField (): Generator<*, void, *> {
  const field = yield select(selectedField$)
  const getFieldId = traverse(['id'])

  yield put(featureOperator.actionCreators.delete({
    model: getFieldId(field),
    submitting: false,
  }))

  const {submit} = yield race({
    submit: take(featureOperator.actionTypes.submitOperation()),
    cancel: take(featureOperator.actionTypes.cancelOperation()),
  })

  const operation = yield select(featureOperation$)
  if (submit) {
    const {error} = yield call(controller.delete, {
      id: getFieldId(field),
    })
    if (!error) {
      yield put(featureOperator.actionCreators.updateOperation({
        ...operation,
        submitting: false,
        success: true,
        errors: [],
      }))
    } else {
      yield put(featureOperator.actionCreators.updateOperation({
        ...operation,
        submitting: false,
        success: false,
        errors: error,
      }))
    }
    yield put(featureOperator.actionCreators.cancelOperation(operation))
  }
}
